import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { ProjectService } from '../../services/project.service';
import { DatasService } from 'src/app/services/datas.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'ng-hbm-bdi-project-duplicate',
  templateUrl: './project-duplicate.component.html'
})
export class ProjectDuplicateComponent implements OnInit {

  public currentName: string;
  public currentError: number;
  public isLoading: boolean;

  constructor(public modal: ModalService, 
    private projectService: ProjectService, 
    private dataService: DatasService,
    private userService: UserService
  ) {
    this.currentName = this.modal.currentDatas.projectName;
    this.currentError = 0;
  }

  ngOnInit(): void { }

  checkForm() {
    this.currentError = 0;
    if (this.currentName.trim() == "") {
      this.currentError = 1;
    }
    if (this.currentName == this.modal.currentDatas.projectName) {
      this.currentError = 2;
    }
  }

  submit() {
    this.checkForm();
    if (this.currentError == 0) {
      this.projectService.duplicate(this.modal.currentDatas.projectID, this.modal.currentDatas.projectUUID, this.currentName.trim()).then((newProject) => {
        if (this.modal.currentDatas.onClose) {
          this.modal.currentDatas.onClose(newProject.projectUUID);
        };              
      }, (error) => {
        console.error(error);
        this.currentError = 3;
      });
    }
  }

  cancel() {
    if (this.modal.currentDatas.onClose) {
      this.modal.currentDatas.onClose(null);
    }
  }
}
